import omit from 'lodash/omit';
import CarrotIcon from '@mui/icons-material/KeyboardArrowDown';
import Stack from '@mui/material/Stack';

import {getSpecialties} from '../../helpers/selectOptions';

const EmbeddedSearchBar = props => {
  const {filter, onFilterChange} = props;
  // use media query to determine if width is less than 612px
  const isMobile = window.innerWidth < 612;
  return (
    <Stack 
      direction={isMobile ? 'column' : 'row'} 
      padding='1em' 
      alignItems='center' 
      spacing={0}
    >
      <div>
        <select
          placeholder="All Specialties"
          defaultValue={filter?.specialty || ''}
          style={{
            width: isMobile ? '325px' : null,
            minWidth: '325px',
            borderRight: 'none',
            borderRadius: isMobile ? '5px 5px 5px 5px' : '2em 0em 0em 2em',
            border: '1px solid rgb(240,240,240)',
            height: '50px',
            fontSize: '0.8rem',
            padding: '0 1em',
            boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
            transition: 'border-color 0.3s ease',
            outline: 'none',
            // remove default browser styles
            appearance: 'none',
            WebkitAppearance: 'none',
            MozAppearance: 'none',
            background: 'rgb(240,240,240, 0.8)',
            color: '#333',
            transition: 'border-color 0.3s ease',
            cursor: 'pointer',
            zIndex: 2,
          }}
          onChange={(e, val) => onFilterChange(
            e, 
            e?.target?.value 
            ? {...filter, specialty: e?.target?.value}
            : {text: filter?.text}
          )}
        >
          {[{value: '', label: 'All Specialties'}, ...getSpecialties()].map(o =>
            <option key={o.value} value={o.value} disabled={!!o.disabled}>
              {o.label}
            </option>
          )}
        </select>
        <span style={{position: 'relative', top: '10px', zIndex: 1, pointerEvents: 'none'}}>
          <CarrotIcon style={{marginLeft: '-1em'}}/>
        </span>
      </div>
      <input
        aria-invalid="false"
        class="MuiInputBase-input MuiOutlinedInput-input"
        type="text"
        data-testid="…"
        placeholder="Enter your city, zip, or a PT's name"
        defaultValue={filter?.text || ''}
        style={{
          borderRadius: isMobile ? '2em 2em 2em 2em' : '0em 2em 2em 0em',
          marginTop: isMobile ? '1em' : null,
          minWidth: isMobile ? '100%' : '350px',
          width: isMobile ? '250px' : null,
          height: '50px',
          fontSize: '1.1rem',
          border: '1px solid rgb(240,240,240)',
          padding: '0 1em',
          boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
          // on hover lighten the color
          transition: 'border-color 0.3s ease',
          outline: 'none',
        }}
        onChange={e => onFilterChange(e, {...filter, text: e.target.value})}
      />
      {/* <CustomTextField
        size='small'
        onChange={e => props.onFilterChange(e, {text: e.target.value})}
        placeholder="Enter your city, zip, or a PT's name"
        sx={{minWidth: 350, borderRadius: '10%'}}
        InputProps={{
          startAdornment: <InputAdornment position="start">
            <SearchIcon color='primary' />
          </InputAdornment>
        }}
      /> */}
  </Stack>
  );
};

export default EmbeddedSearchBar;